import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowsTodo from './FlowsTodo';

const FlowsTodoBridge = react2angular(FlowsTodo, ['backFromState']);

export default FlowsTodoBridge;
